import { Alert, Box, Button, CircularProgress } from '@mui/material';

import { CpfSearchForm } from './CpfSearchForm';
import { ProfileForm } from './ProfileForm';

import type { Profile as ProfileData, ProfileUpdate } from '@services/profile/profile.types';

export type ProfilePageStatus = 'search' | 'loading' | 'error' | 'ready';

export interface ProfileProps {
  status: ProfilePageStatus;
  profile: ProfileData | null;
  pageError: string;
  isSearching: boolean;
  onSearch: (cpf: string) => void;
  onSave: (update: ProfileUpdate) => Promise<void>;
  onBack: () => void;
}

export const Profile = ({ status, profile, pageError, isSearching, onSearch, onSave, onBack }: ProfileProps) => {
  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', px: 2, py: 4, width: '100%' }}>
      {status === 'search' && <CpfSearchForm onSearch={onSearch} isLoading={isSearching} />}

      {status === 'loading' && (
        <Box display="flex" justifyContent="center" mt={8}>
          <CircularProgress />
        </Box>
      )}

      {status === 'error' && (
        <Box maxWidth={480} mx="auto" mt={6} display="flex" flexDirection="column" gap={2}>
          <Alert severity="error">{pageError}</Alert>
          <Button variant="outlined" onClick={onBack} sx={{ alignSelf: 'flex-start' }}>
            Voltar
          </Button>
        </Box>
      )}

      {status === 'ready' && profile && <ProfileForm initialProfile={profile} onSubmit={onSave} onBack={onBack} />}
    </Box>
  );
};
